<template>
    <div class="position-box">
        <div class="head">
            <img class="back" src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('wydb.dbjl')}}</div>
        </div>
        <div class="cotainer">
            <ul class="ul-box">
                <li class="li" v-for="(item,index) in list" :key="index">
                    <div class="li-head">
                        <div class="t1">{{$t('wydb.hkhth')}} {{item.no}}</div>
                        <div class="t2" :class="{active: item.status == 1}">{{item.status_name}}</div>
                    </div>
                    <div class="time">{{$t('wydb.sqrq')}} {{item.start_time_format}}</div>
                    <div class="type-box"><span class="t1 text">{{$t('wydb.zq')}} {{item.cycle_days}}</span><span v-show="item.status == 1" class="t2 text" @click="goHk(item.id,item)">{{$t('wydb.qhk')}}</span></div>
                    <div class="item-box">
                        <div class="item">
                            <div class="t1">{{$t('wydb.dbsl')}}</div>
                            <div class="t2">{{item.amount}} USDC</div>
                        </div>
                        <div class="item">
                            <div class="t1 center">{{$t('wydb.lx')}}</div>
                            <div class="t2 center">{{item.interest}} USDC</div>
                        </div>
                        <div class="item">
                            <div class="t1 text-right">{{$t('wydb.zhke')}}</div>
                            <div class="t2 text-right">{{(parseFloat(item.amount) + parseFloat(item.interest)).toFixed(4)}} USDC</div>
                        </div>
                    </div>
                </li>
            </ul>
            <!-- 暂无数据 -->
            <no-data v-show="isNoData"></no-data>
        </div>
    </div>
</template>

<script>
import noData from '@/components/noData.vue'
export default {
    name: 'currencyRecord',
    data () {
        return {
            isNoData: true,
            tabIdx: 2,
            list: [],
            isGoTOP: false,
            curDataLength: 10,
            theme: false,
            page: 1
        }
    },
    created(){
        this.theme = JSON.parse(localStorage.getItem('theme'))
    },
    mounted() {
       this.getMylist()
    },
    methods: {
       back(){
           this.$router.push('/currency')
       },
       getMylist(){
            let params = {page: this.page};
            this.$ajax.get('/web/lendMylist',{params}).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 1000){
                  setTimeout(()=>{
                    this.$router.push('/index');
                  },1000)
                  return false
                }
                if(resData.length > 0){
                    this.list = this.list.concat(resData);
                    this.curDataLength = resData.length;
                }else{
                    this.curDataLength = resData.length;
                }
                if(this.list.length > 0){
                    this.isNoData = false;
                }else{
                    this.isNoData = true;
                }
            }).catch(function(err){
                console.log(err)
            })
       },
       goHk(id,item){
            localStorage.setItem('hkCont',JSON.stringify(item));
            if(item.lend_type == "chain_address"){
              this.$router.push({ path: '/repayment', query: { id: id } })
            }else{
              this.$router.push({ path: '/repayment2', query: { id: id } })
            }
        },
    },
    components:{
        noData,
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
      .position-box{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
      }
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .36rem;
        margin-top: -.4rem;
    }
    .head .title{
      color: #fff;
        font-size: .52rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        left: .42rem;
        right: .42rem;
        top: 1.6rem;
        bottom: 0;
        overflow-y: scroll;
    }
    .ul-box .li{
        margin-top: .36rem;
        padding: .66rem .3rem;
        border-radius: .26rem;
        background: #131e30;
    }
    .ul-box .li .li-head{
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #fff;
        font-size: .36rem;
    }
    .ul-box .li .li-head .t2.active{
        color: #009D1E;
    }
    .ul-box .li .time{
        padding: .42rem 0;
        color: #8A8A8A;
        font-size: .36rem;
    }
    .ul-box .li .type-box .text{
        display: inline-block;
        margin-right: .24rem;
        padding: .12rem .42rem;
        font-size: .36rem;
        border-radius: 3px;
    }
    .ul-box .li .type-box .t1{
        color: #123F7D;
        background: #DFEDFF;
    }
    .ul-box .li .type-box .t2{
        color: #fff;
        background: #FA0000;
    }
    .ul-box .li .item-box{
        display: flex;
        justify-content: space-between;
        align-items: stretch;
        margin-top: .6rem;
    }
    .ul-box .li .item-box .item .t1{
        color: #8A8A8A;
        font-size: .36rem;
    }
    .ul-box .li .item-box .item .t2{
        padding-top: .3rem;
        color: #fff;
        font-size: .36rem;
    }
    .ul-box .li .item-box .item .center{
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/currencyRecord.vue